var exports = {
  "kL": "Tabs.module__container___dUowbm",
  "Mf": "Tabs.module__tab___dUowbm",
  "wH": "Tabs.module__selected___dUowbm",
};

module.exports = exports;
